import React from "react";
import { QRCodeSVG } from "qrcode.react";

/** Simple QR code wrapper so we can swap libraries if needed. */
export default function QRCode({ value, size = 180, className = "" }) {
  return (
    <div className={`inline-block bg-white p-3 rounded-xl border border-zinc-200 ${className}`}>
      <QRCodeSVG value={value} size={size} level="M" includeMargin={false} />
    </div>
  );
}
